<template>
	<div class="addCpct">
		<el-drawer v-loading="loading" custom-class="addCpDrawer" title="添加产品" :visible.sync="drawer" size="22%"
			@close="drawerClose" @opened="drawOpen">
			<template v-if="stepUp == 1">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="产品编号：" prop="name">
						<el-input v-model="ruleForm.name" @focus="nameFous" placeholder="请输入产品编号"></el-input>
					</el-form-item>
					<el-form-item label="产品密码：" prop="password">
						<el-input v-model="ruleForm.password" @focus="passwordFous" show-password
							placeholder="请输入产品密码"></el-input>
					</el-form-item>
				</el-form>
				<div class="btn-box">
					<el-button class="myElBtn" @click="submitForm('ruleForm')">确定</el-button>
				</div>
			</template>
			<template v-if="stepUp == 2">
				<div class="step2">
					<div class="yuan">
						<div class="huan"></div>
						<div class="huan huan1"></div>
						<div class="huan huan2"></div>
					</div>
					<div class="txt">加载中，请稍等...</div>
				</div>


			</template>
			<template v-if="stepUp == 3">
				<div class="step3">
					<template v-if="result == 0">
						<img src="@/assets/image/equipment/addcp.png" alt="" class="img">
						<div class="txt">添加失败</div>
						<div class="btn" @click="again()">重新添加</div>
					</template>
					<template v-if="result == 1">
						<img src="@/assets/image/equipment/addcp2.png" alt="" class="img">
						<div class="txt">添加成功</div>
						<div class="btn" @click="back()">返回</div>
					</template>
				</div>
			</template>

		</el-drawer>
		<Msg ref="tjmsg"></Msg>
	</div>
</template>

<script>
import Msg from '@/components/msg.vue' //信息提示组件
export default {
	components: { Msg },
	data() {
		return {
			loading: false,
			// 控制抽屉的开关
			drawer: false,
			//   验证规则
			rules: {
				name: [
					{ required: true, message: '请输入产品编号', trigger: 'blur' },
					{
						min: 8,
						max: 25,
						message: '长度在 8 到 25 个字符',
						trigger: 'blur',
					},
				],
				password: [{ required: true, message: '请输入产品密码', trigger: 'blur' }],
			},
			//   表单数据
			ruleForm: {
				name: '',
				password: '',
			},
			stepUp: 1,//1 添加前 2添加中 3添加后
			result: 0,//0失败 1成功
		}
	},
	methods: {
		// 鼠标获取焦点
		nameFous() {
			this.$refs['ruleForm'].clearValidate('name') //获取焦点时如果有效验结果清除结果
		},
		passwordFous() {
			this.$refs['ruleForm'].clearValidate('password') //获取焦点时如果有效验结果清除结果
		},
		// 确定
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// this.loading = true
					// this.bindDevice()
					this.queryProductInfo()
				} else {
					return false
				}
			})
		},
		// 添加产品
		bindDevice() {
			// this.loading = true;
			this.stepUp = 2;
			setTimeout(() => {
				this.$http
					.postAction(
						this.$api.bindDevice +
						'?deviceCompNum=' +
						this.ruleForm.name +
						'&devicePass=' +
						this.ruleForm.password
					)
					.then((res) => {
						this.stepUp = 3;
						console.log(res)

						if (res.code == 200) {
							console.log(res.code);
							// this.loading = false
							this.$refs.tjmsg.msgShow('添加成功', 1.5)
							// this.$refs['ruleForm'].resetFields()
							// this.drawer = false;
							this.result = 1
							this.$bus.$emit('getMyDevice')
							// setTimeout(() => {
							//   this.$bus.$emit("openDrwer");
							// }, 500);
						} else {
							// this.loading = false

							if (res.msg == '无该设备信息！') {
								this.$refs.tjmsg.msgShow('无该产品信息！', 1.5)
							} else {
								this.$refs.tjmsg.msgShow(res.msg, 1.5)
							}
							this.result = 0
						}
					})
			}, 800)

		},
		drawOpen() {
			console.log("执行");
			this.stepUp = 1;
			this.$nextTick(() => {
				this.$refs['ruleForm'].resetFields()
			})

		},
		// 抽屉关闭
		drawerClose() {
			this.ruleForm.name = ""
			this.ruleForm.password = ""
			this.stepUp = 1;
			// this.$refs['ruleForm'].resetFields()
			this.drawer = false;
			this.result = 0
			this.$bus.$emit('getMyDevice')

		},
		back() {
			this.drawer = false;
		},
		again() {
			this.result = 0
			this.stepUp = 1;
			this.$refs['ruleForm'].resetFields()
		},
		// 先判断是4G设备还是WiFi设备
		queryProductInfo() {
			this.$http
				.postAction(
					this.$api.deviceproductinfo +
					'?deviceCompNum=' +
					this.ruleForm.name +
					'&devicePass=' +
					this.ruleForm.password
				).then((res) => {
					if (res.data) {
						if (res.data.netTypeDesc.indexOf('WIFI') == -1) {
							this.bindDevice()
						} else {
							//当前设备为WiFi设备
							this.toWIFIDevice()
						}
					} else {
						this.$refs.tjmsg.msgShow(res.msg, 1.5)
					}
				})
		},
		// WiFi设备
		toWIFIDevice() {
			let that = this
			this.$http.getAction(this.$api.getdevicestatus + "?deviceNum=" + this.ruleForm.name).then((res) => {
				if (res.data.onlineState == 'online') {
					this.bindDevice()
				} else {
					this.$refs.tjmsg.msgShow('设备离线 请使用小程序进行配网', 1.5)
				}
			})
		},
	},
}
</script>

<style lang="scss">
.addCpct {
	.addCpDrawer {
		border-radius: 0.225rem 0px 0px 0.225rem;

		.el-drawer__header {
			height: 0.825rem;
			box-sizing: border-box;
			text-align: left;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #454545;
			padding-top: 0;
			border-bottom: 1px solid #f1f1f1;

			span {
				font-size: 0.225rem;
			}
		}

		.el-drawer__close-btn {
			color: #454545;
		}

		.el-drawer__body {
			padding: 0 0.3rem 0.25rem;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.el-input.is-active .el-input__inner,
			.el-input__inner:focus {
				border-color: #2daea9;
			}

			.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,
			.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
				display: none;
			}

			.btn-box {
				width: 100%;

				.myElBtn {
					width: 1.75rem;
					background: #2daea9;
					border-color: transparent;
					color: #ffffff;
				}
			}

			.step2 {
				display: flex;
				flex-direction: column;
				align-items: center;

				.yuan {
					margin-top: 1.5rem;
					position: relative;
					width: 1.7875rem;
					height: 1.7875rem;
					background: url("~@/assets/image/equipment/csh.png") no-repeat;
					background-size: 100% 100%;
					animation: rotate 2s linear infinite;
					/* 2秒钟完成一次旋转，线性速度，无限循环 */
				}

				.huan {
					position: absolute;
					top: 0;
					left: 0;
					width: 1.7875rem;
					height: 1.7875rem;
					border-radius: 50%;
					border: 1px solid #2DAEA9;
					animation: spread-out 3s ease-out infinite;
					/* 3秒钟完成一次扩散，使用ease-out来平滑动画，循环播放 */

				}

				.huan1 {
					opacity: 0;
					animation-delay: 1s;
					/* 延迟1秒后开始执行动画 */
				}

				.huan1 {
					opacity: 0;
					animation-delay: 2s;
					/* 延迟1秒后开始执行动画 */
				}

				/* 创建旋转动画 */
				@keyframes rotate {
					0% {
						transform: rotate(0deg);
					}

					100% {
						transform: rotate(360deg);
					}
				}

				/* 创建扩散并消失的动画 */
				@keyframes spread-out {
					0% {
						transform: scale(1);
						opacity: 1;
					}

					100% {
						transform: scale(2.1);
						/* 扩展到原来的10倍大小 */
						opacity: 0;
						/* 透明度消失 */
					}
				}

				.txt {
					margin-top: 1.425rem;
				}

			}

			.step3 {
				.img {
					margin-top: 1.95rem;
					width: 2.2375rem;
					height: 2.2375rem;
				}

				.txt {
					margin-top: .45rem;
					margin-bottom: .5rem;
				}

				.btn {
					cursor: pointer;
					margin: 0 auto;
					width: 1.75rem;
					height: .45rem;
					background: #2DAEA9;
					border-radius: 4px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-family: Microsoft YaHei;
					font-weight: 400;
					font-size: 14px;
					color: #FEFFFF;
				}
			}

		}
	}
}
</style>
